import { useEffect, useState } from 'react';
import { LuckySpinRouletteLightProps } from './props';
import styles from './styles.module.scss';
import { Image } from '@starsoft/common/components';

export default function LuckySpinRouletteLight({
  isSpinning,
}: LuckySpinRouletteLightProps) {
  const [tick, setTick] = useState<boolean>(false);

  function handleAnimation() {
    const interval = setInterval(() => {
      setTick(prev => !prev);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }

  useEffect(handleAnimation, []);

  return (
    <Image
      alt="rolette lights"
      format="square"
      width={348}
      height={348}
      className={`${styles.container} ${isSpinning ? styles['container--spinning'] : ''} ${tick ? styles['container--spin'] : ''} `}
      preload
      src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/lucky-spin/Bronze/svg/ice-spin-light.svg`}
      secondarySkeleton
    />
  );
}
